import type { Article } from './articleApi';

/** 表示上の公開日（publishedAt）と一致。日付のみなら JST 0時として表現 */
export function publishedAtToIso8601(publishedAt: string): string {
  const d = publishedAt.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(d)) {
    return `${d}T00:00:00+09:00`;
  }
  const t = Date.parse(d);
  if (!Number.isNaN(t)) {
    return new Date(t).toISOString();
  }
  return new Date().toISOString();
}

function toAbsoluteUrl(href: string, origin: string): string {
  try {
    return new URL(href, origin).href;
  } catch {
    return href;
  }
}

const PUBLISHER_NAME = 'Social Trip';
/** index.html / Footer と整合。OG 用の正方形に近いアイコン */
const PUBLISHER_LOGO_PATH = '/apple-touch-icon.png';

/**
 * 記事詳細用 Article JSON-LD（標準フィールド＋ url / mainEntityOfPage）
 * dateModified は Article に updatedAt が無いため publishedAt と同値（編集日を別管理する場合は差し替え）
 */
export function buildArticleJsonLd(article: Article, pageUrl: string): Record<string, unknown> {
  const origin = new URL(pageUrl).origin;
  const logoUrl = toAbsoluteUrl(PUBLISHER_LOGO_PATH, origin);
  const imageUrl = toAbsoluteUrl(article.image, origin);
  const isoPublished = publishedAtToIso8601(article.publishedAt);
  const isoModified = isoPublished;

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: imageUrl,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    publisher: {
      '@type': 'Organization',
      name: PUBLISHER_NAME,
      logo: {
        '@type': 'ImageObject',
        url: logoUrl,
      },
    },
    datePublished: isoPublished,
    dateModified: isoModified,
    url: pageUrl,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pageUrl,
    },
  };
}
